import Sortable from 'sortablejs';
import _ from 'lodash';

function onAdd(item, type) {
  $(item).find('input').val(`transport_${type}`);
  $(item).parents('#config-form').data('changed', true);
}
function onAddDefault(e) {
  onAdd(e.item, 'default');
}
function onAddPublic(e) {
  onAdd(e.item, 'public');
}
function onAddSchool(e) {
  onAdd(e.item, 'school');
}

$(document).on('ready turbolinks:load', () => {
  const $listDefault = $('#class-list-td');
  const $listPublic = $('#class-list-tp');
  const $listSchool = $('#class-list-ts');
  if (!$listDefault.length) {
    return;
  }

  Sortable.utils.off($listDefault.get(0), 'add', onAddDefault);
  Sortable.utils.off($listPublic.get(0), 'add', onAddPublic);
  Sortable.utils.off($listSchool.get(0), 'add', onAddSchool);

  Sortable.utils.on($listDefault.get(0), 'add', onAddDefault);
  Sortable.utils.on($listPublic.get(0), 'add', onAddPublic);
  Sortable.utils.on($listSchool.get(0), 'add', onAddSchool);

  _.forEach([$listDefault, $listPublic, $listSchool], $ul => $ul.find('li a').off('click').on('click', (event) => {
    const $li = $(event.currentTarget).parent('li');
    $listDefault.append($li);
    onAdd($li.get(0), 'default');
  }));
});
